import { useState } from "react";

import { unavailableMediaUrl } from "./media-url";

/** The same missing/unavailable image state in the gallery and post list. */
export function PostImage({
  url,
  title = "投稿の画像",
  gallery = false,
}: {
  url: string | null;
  title?: string;
  gallery?: boolean;
}) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  if (!url) return <p>画像なし</p>;
  if (unavailableMediaUrl(url) || failedUrl === url)
    return <p>画像を出せません</p>;
  return (
    <img
      className={
        gallery ? undefined : "vd-product-image vd-product-image--thumb"
      }
      src={url}
      alt={title}
      width={gallery ? undefined : 64}
      height={gallery ? 220 : 64}
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setFailedUrl(url)}
      style={
        gallery
          ? { width: "100%", height: 220, objectFit: "cover", borderRadius: 6 }
          : undefined
      }
    />
  );
}
